/**
 * @generated SignedSource<<7a50cafa9bd83c3ea8e932efd6bc7adc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type SetTextCopyButtonInPageInput = {
  clientMutationId?: string | null;
  messageDefinitionId: string;
  pageId: string;
  text: string;
};
export type useMessagePageButtonMutations_SetTextCopyButtonMutation$variables = {
  connections: ReadonlyArray<string>;
  input: SetTextCopyButtonInPageInput;
};
export type useMessagePageButtonMutations_SetTextCopyButtonMutation$data = {
  readonly Admin: {
    readonly MessageDefinitions: {
      readonly setTextCopyButtonInPage: {
        readonly messageDefinition: {
          readonly node: {
            readonly id: string;
          };
        };
      } | null;
    };
  };
};
export type useMessagePageButtonMutations_SetTextCopyButtonMutation = {
  response: useMessagePageButtonMutations_SetTextCopyButtonMutation$data;
  variables: useMessagePageButtonMutations_SetTextCopyButtonMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "connections"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v2 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "MessageDefinitionsEdge",
  "kind": "LinkedField",
  "name": "messageDefinition",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "MessageDefinition",
      "kind": "LinkedField",
      "name": "node",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "useMessagePageButtonMutations_SetTextCopyButtonMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminMutationType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "MessageDefinitionsAdminMutationSchema",
            "kind": "LinkedField",
            "name": "MessageDefinitions",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v2/*: any*/),
                "concreteType": "SetTextCopyButtonInPagePayload",
                "kind": "LinkedField",
                "name": "setTextCopyButtonInPage",
                "plural": false,
                "selections": [
                  (v3/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "useMessagePageButtonMutations_SetTextCopyButtonMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminMutationType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "MessageDefinitionsAdminMutationSchema",
            "kind": "LinkedField",
            "name": "MessageDefinitions",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v2/*: any*/),
                "concreteType": "SetTextCopyButtonInPagePayload",
                "kind": "LinkedField",
                "name": "setTextCopyButtonInPage",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "filters": null,
                    "handle": "appendEdge",
                    "key": "",
                    "kind": "LinkedHandle",
                    "name": "messageDefinition",
                    "handleArgs": [
                      {
                        "kind": "Variable",
                        "name": "connections",
                        "variableName": "connections"
                      }
                    ]
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "01ab2e66f02a254d65fb49c93bd041a9",
    "id": null,
    "metadata": {},
    "name": "useMessagePageButtonMutations_SetTextCopyButtonMutation",
    "operationKind": "mutation",
    "text": "mutation useMessagePageButtonMutations_SetTextCopyButtonMutation(\n  $input: SetTextCopyButtonInPageInput!\n) {\n  Admin {\n    MessageDefinitions {\n      setTextCopyButtonInPage(input: $input) {\n        messageDefinition {\n          node {\n            id\n          }\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "155bdc8fcb4dc74ef92f44d7a9bb1fe5";

export default node;
